module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"videoProcessingFailed":"К сожалению, интервью пока не открыто. Вы можете попросить отправителя открыть его."}}')
  delete Component.options._Ctor
}
